import React, { Component } from 'react';

export class ErrorBoundaryComponent extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // TODO: Possibly Include appLogger Here
    this.props.errorCapture(error);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <div className="WrapperError" style="display:none;"></div>;
    }

    return this.props.children;
  }
}

export default function errorWrapper(WrappedComponent) {
  return class Wrapper extends Component {
    render() {
      const { opts } = this.props;

      return (
        <ErrorBoundaryComponent errorCapture={opts.errorCapture}>
          <WrappedComponent {...this.props} />
        </ErrorBoundaryComponent>
      );
    }
  };
} 